module.exports = __webpack_public_path__ + "static/media/cadarcos-algodao-350x210.6ab4711c.png";